import {i18n} from "@/lang";
import icon6 from "@/assets/dashboard/6.png";
import icon7 from "@/assets/dashboard/7.png";
import icon8 from "@/assets/dashboard/8.png";
import icon9 from "@/assets/dashboard/9.png";
import icon10 from "@/assets/dashboard/10.png";

export const objToArrays = (obj) => {
    const keyMap = [
        {
            key: 'unReadCount',
            name: i18n.global.t("common.email.noread"),
            icon: icon6,
            countRed: true,
        },
        {
            key: 'followCount',
            name: i18n.global.t("common.followup.emailremind"),
            icon: icon7,
            countRed: true,
        },
        {
            key: 'failCount',
            name: i18n.global.t("common.send.failed"),
            icon: icon9,
        },
        {
            key: 'auditCount',
            name: i18n.global.t("common.email.toexamine"),
            icon: icon8,
        },
        {
            key: 'receiveCount',
            name: i18n.global.t("common.claim.toexamine"),
            icon: icon10,
        },
        {
            key: 'customerFollowCount',
            name: '客户跟进',
        }
    ];

    return keyMap
        .filter(item => obj[item.key] !== undefined)
        .map(item => ({
            name: item.name,
            count: obj[item.key],
            icon: item.icon,
            countRed: item.countRed || false,
        }));
}